var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalUsersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4709 3.08604H11.434C10.2166 3.08604 9.22662 4.07605 9.22662 5.29342V9.70817H4.81187C3.5945 9.70817 2.60449 10.6982 2.60449 11.9156V22.9524C2.60449 24.1698 3.5945 25.1598 4.81187 25.1598H15.8488C17.0661 25.1598 18.0561 24.1698 18.0561 22.9524V18.5377H22.4709C23.6883 18.5377 24.6783 17.5477 24.6783 16.3303V5.29342C24.6783 4.07605 23.6883 3.08604 22.4709 3.08604ZM4.81187 22.9524V11.9155H15.8488L15.851 22.9524H4.81187ZM22.4709 16.3303H18.0561V11.9156C18.0561 10.6982 17.0661 9.70817 15.8488 9.70817H11.434V5.29342H22.4709V16.3303Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01904 14.1229H13.6412V16.3303H7.01904V14.1229ZM7.01904 18.5377H13.6412V20.7451H7.01904V18.5377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsersIcon);
export default __webpack_public_path__ + "static/media/total-users-icon.88f23e01ee73f79cc457d2ac81443e7d.svg";
export { ForwardRef as ReactComponent };